// extracted by mini-css-extract-plugin
export default {"mbMenu":"mobile-bottom-menu_mbMenu__5glU4","wrapper":"mobile-bottom-menu_wrapper__rbQrw"};